import {version} from '../../package.json';

export const VERSION_APP = version;

export default {VERSION_APP}

